/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Actions/AzureRMActions" />
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { AzureRMKeys } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/AzureRMEndpointConstants";
import { AzureManagementGroup, AzureMLWorkspace, AzureAppService } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

export class AzureRMActions extends ActionsHubBase {
    public  static getKey(): string {
        return AzureRMKeys.ACTIONS_KEY;
    }

    public initialize(instanceId?: string): void {
        this._setAccessToken = new Action<string>();
        this._updateErrorMessage = new Action<string>();
        this._updateResourceGroupList = new Action<string[]>();
        this._fetchingMoreResourceGroups = new Action<boolean>();
        this._updateManagementGroupList = new Action<AzureManagementGroup[]>();
        this._fetchingManagementGroups = new Action<boolean>();
        this._updateMLWorkspaceList = new Action<AzureMLWorkspace[]>();
        this._fetchingMoreMLWorkspaces = new Action<boolean>();
        this._updateAppServiceAndSlotList = new Action<AzureAppService[]>();
        this._fetchingMoreAppServiceAndSlot = new Action<boolean>();
    }

    public get setAccessToken(): Action<string> {
        return this._setAccessToken;
    }

    public get updateResourceGroupList(): Action<string[]> {
        return this._updateResourceGroupList;
    }

    public get fetchingMoreResourceGroups(): Action<boolean> {
        return this._fetchingMoreResourceGroups;
    }

    public get updateManagementGroupList(): Action<AzureManagementGroup[]> {
        return this._updateManagementGroupList;
    }

    public get fetchingManagementGroups(): Action<boolean> {
        return this._fetchingManagementGroups;
    }

    public get updateMLWorkspaceList(): Action<AzureMLWorkspace[]> {
        return this._updateMLWorkspaceList;
    }

    public get fetchingMoreMLWorkspaces(): Action<boolean> {
        return this._fetchingMoreMLWorkspaces;
    }

    public get updateAppServiceAndSlotList(): Action<AzureAppService[]> {
        return this._updateAppServiceAndSlotList;
    }

    public get fetchingMoreAppServiceAndSlot(): Action<boolean> {
        return this._fetchingMoreAppServiceAndSlot;
    }

    public get updateErrorMessage(): Action<string> {
        return this._updateErrorMessage;
    }

    private _setAccessToken: Action<string>;
    private _updateErrorMessage: Action<string>;
    private _updateResourceGroupList: Action<string[]>;
    private _fetchingMoreResourceGroups: Action<boolean>;
    private _updateManagementGroupList: Action<AzureManagementGroup[]>;
    private _fetchingManagementGroups: Action<boolean>;
    private _updateMLWorkspaceList: Action<AzureMLWorkspace[]>;
    private _fetchingMoreMLWorkspaces: Action<boolean>;
    private _updateAppServiceAndSlotList: Action<AzureAppService[]>;
    private _fetchingMoreAppServiceAndSlot: Action<boolean>;
}